import { Navigate, useLocation } from 'react-router-dom';

const isTokenValid = () => {
    const token = localStorage.getItem('access_token');
    if (!token) return false;
    const expiry = localStorage.getItem('token_expiry');
    if (!expiry) return false;
    return new Date() < new Date(expiry);
};

// Wraps any protected route. Redirects to "/" immediately if the token is
// absent or expired — runs synchronously during render so there is no flash.
const PrivateRoute = ({ children }) => {
    const location = useLocation();

    if (!isTokenValid()) {
        localStorage.clear();
        return <Navigate to="/" replace state={{ from: location }} />;
    }

    return children;
};

export default PrivateRoute;
